import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=fde217a2"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetails.vue?vue&type=style&index=0&id=fde217a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports